import React from 'react'
import styles from './styles/Input.module.css'

interface IMonthInputProps {
  /** Id do input, para associar um <label htmlFor>. */
  id?: string
  name?: string
  /** Mês no formato AAAA-MM (ex.: competência de relatório mensal). */
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  /** Limites no formato AAAA-MM. */
  minMonth?: string
  maxMonth?: string
  required?: boolean
  disabled?: boolean
  isValid?: boolean
  isInvalid?: boolean
  className?: string
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}

/**
 * Seleção de mês/ano (`<input type="month">` nativo, sem lib), com o visual dos demais inputs.
 * O valor é a string AAAA-MM; navegadores sem seletor de mês mostram um campo de texto, por isso
 * o placeholder indica o formato.
 */
export const MonthInput: React.FC<IMonthInputProps> = ({
  value = '',
  onChange,
  minMonth,
  maxMonth,
  required = false,
  disabled = false,
  isValid,
  isInvalid,
  className = '',
  ...props
}) => {
  const inputClasses = [
    'form-control form-control-solid',
    isInvalid ? 'is-invalid' : isValid ? 'is-valid' : '',
    disabled ? styles.disabledInput : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <input
      {...props}
      type='month'
      className={inputClasses}
      placeholder='AAAA-MM'
      value={value}
      onChange={onChange}
      min={minMonth}
      max={maxMonth}
      required={required}
      disabled={disabled}
      aria-invalid={props['aria-invalid'] ?? Boolean(isInvalid)}
    />
  )
}
